import { QuestionPageFormData } from '@features/Funnel/screens/FunnelPage/QuestionPage/QuestionPageScreen';
import { useCallback, useEffect } from 'react';
import { UseFieldArrayReplace, UseFormSetValue } from 'react-hook-form';

import { useQueryParams } from 'src/app/hooks/useQueryParams';

import { questionPayloadFactory } from '../../utils/questionFunnelsPageFactory';
import { useTryToRequestQuestionPage } from './useTryToRequestQuestionPage';
import { useTryToRequestUpdateQuestionPage } from './useTryToRequestUpdateQuestionPage';

interface UseRequestQuestionPageProps {
  setTitlePage: React.Dispatch<React.SetStateAction<string>>;
  titlePage: string;
  setValue: UseFormSetValue<QuestionPageFormData>;
  isUpdate: boolean;
  setIsUpdate: React.Dispatch<React.SetStateAction<boolean>>;
  replace: UseFieldArrayReplace<QuestionPageFormData, 'answers'>;
}

export function useRequestQuestionPage({
  setTitlePage,
  setValue,
  replace,
  isUpdate,
  setIsUpdate,
  titlePage,
}: UseRequestQuestionPageProps) {
  const params = useQueryParams();
  const pageId = params.get('pageId');

  const { tryToRequestQuestionPage } = useTryToRequestQuestionPage();
  const { tryToRequestUpdateQuestionPage, isLoading } =
    useTryToRequestUpdateQuestionPage();

  const handleRequestQuestionPage = useCallback(async () => {
    await tryToRequestQuestionPage(pageId as string).then(questionFormData => {
      setValue(
        'cancellationFunnelId',
        `${questionFormData.cancellationFunnelId}`
      );
      setValue('title', questionFormData.title);
      setValue('subtitle', questionFormData.subtitle);
      replace(questionFormData.answers);
      setValue(
        'continueCancelationButtonTitle',
        questionFormData.continueCancelationButtonTitle
      );
      setValue(
        'keepSubscriptionButtonTitle',
        questionFormData.keepSubscriptionButtonTitle
      );
      setTitlePage(questionFormData.name);
    });
  }, [pageId, setTitlePage]);

  const handleUpdateQuestionPage = useCallback(
    async (e: QuestionPageFormData) => {
      await tryToRequestUpdateQuestionPage({
        id: pageId as string,
        payload: questionPayloadFactory(titlePage, true, e),
      });
    },
    [pageId, useTryToRequestUpdateQuestionPage, titlePage]
  );

  useEffect(() => {
    if (pageId && !isUpdate) {
      handleRequestQuestionPage();
      setIsUpdate(true);
    }
  }, [pageId]);

  return { handleUpdateQuestionPage, isLoadingUpdate: isLoading };
}
